webpackJsonp([76],{

/***/ 1248:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_date_fns__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_date_fns___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_date_fns__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_table_run__ = __webpack_require__(275);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_table_run___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_table_run__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_mixins__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_filters__ = __webpack_require__(278);



var loadData = function () {
	var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
		return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
			while (1) {
				switch (_context.prev = _context.next) {
					case 0:
						_context.next = 2;
						return this.$http.get('bookings', { params: this.params });

					case 2:
					case 'end':
						return _context.stop();
				}
			}
		}, _callee, this);
	}));

	return function loadData() {
		return _ref.apply(this, arguments);
	};
}();

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






function created() {
	this.loadData();
}

function allowedDatesOut(date) {
	var newDay = new Date(this.dateEnter).getDate() + 2;
	var newMonth = new Date(this.dateEnter).getMonth() + 1;
	var newYear = new Date(this.dateEnter).getFullYear();
	var newDate = newYear + '-' + newMonth + '-' + newDay;
	return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_date_fns__["isAfter"])(new Date(date), new Date(newDate));
}

function changeFormatDate(value) {
	return new Date(value).toISOString().substr(0, 10);
}

function changeIcon(result) {
	this.onChange = result;
}

function validDate(date) {
	this.dateOut = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_date_fns__["differenceInDays"])(new Date(this.dateOut), new Date(date)) < 0 ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_date_fns__["format"])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_date_fns__["addDays"])(new Date(date), 2), 'YYYY-MM-DD') : this.dateOut;
}

function data() {
	return {
		columns: [{ id: 1, name: 'Reserva' }, { id: 2, name: 'Huesped' }, { id: 3, name: 'País' }, { id: 4, name: 'Entrada' }, { id: 5, name: 'Salida' }, { id: 6, name: 'Tipo Res' }, { id: 7, name: 'Nº Hab' }, { id: 8, name: 'Tipo Ocu' }, { id: 9, name: 'MP' }, { id: 10, name: 'ANB' }, { id: 11, name: 'Estado' }, { id: 12, name: 'Entidad' }],
		dateCreation: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_date_fns__["format"])(new Date(), 'YYYY-MM-DD'),
		dateEnter: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_date_fns__["format"])(new Date(), 'YYYY-MM-DD'),
		dateOut: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_date_fns__["format"])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_date_fns__["addDays"])(new Date(), 1), 'YYYY-MM-DD'),
		formatted: '',
		loading: false,
		menuEnter: false,
		menuOut: false,
		onChange: false,
		params: {
			code: '',
			dateEnter: '',
			dateOut: '',
			state: 0,
			room: ''
		},
		rows: [],
		status: [{ id: 1, name: 'Reserva' }]
	};
}

/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'booking-filter',
	components: {
		TableRun: __WEBPACK_IMPORTED_MODULE_3_table_run___default.a
	},
	created: created,
	data: data,
	filters: {
		round: __WEBPACK_IMPORTED_MODULE_5__shared_filters__["c" /* round */]
	},
	methods: {
		allowedDatesOut: allowedDatesOut,
		changeFormatDate: changeFormatDate,
		changeIcon: changeIcon,
		loadData: loadData,
		validDate: validDate
	},
	mixins: __WEBPACK_IMPORTED_MODULE_4__shared_mixins__["a" /* default */]
});

/***/ }),

/***/ 1368:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(772)(true);
// imports


// module
exports.push([module.i, ".form-button[data-v-0673c61c]{background-color:transparent;-webkit-box-shadow:none;box-shadow:none}.form-button .btn[data-v-0673c61c]{background-color:#7e7e7e!important;border-radius:0;-webkit-box-shadow:0 2px 4px 0 rgba(0,0,0,.18)!important;box-shadow:0 2px 4px 0 rgba(0,0,0,.18)!important;color:#fff;height:40px;margin-right:14px;min-width:98px;opacity:1}.form-button .btn--active[data-v-0673c61c]{background-color:#29abe2!important}.divider-form[data-v-0673c61c]{margin:0 -20px;width:100vw}.chip[data-v-0673c61c]{background-color:#29abe2;border-radius:0;-webkit-box-shadow:none!important;box-shadow:none!important;font-size:10px;height:18px;line-height:18px;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;padding:0;text-transform:uppercase;width:65px}.disabled-block[data-v-0673c61c]{opacity:.5}.btn-save-form[data-v-0673c61c]{max-width:100%!important}", "", {"version":3,"sources":["/opt/build/repo/src/clerkinn/bookings/Filter.vue"],"names":[],"mappings":"AACA,8BACE,6BAA8B,AAC9B,wBAAyB,AACjB,eAAiB,CAC1B,AACD,mCACI,mCAAqC,AACrC,gBAAmB,AACnB,yDAA+D,AACvD,iDAAuD,AAC/D,WAAa,AACb,YAAa,AACb,kBAAmB,AACnB,eAAgB,AAChB,SAAW,CACd,AACD,2CACM,kCAAqC,CAC1C,AACD,+BACE,eAAgB,AAChB,WAAa,CACd,AACD,uBACE,yBAA0B,AAC1B,gBAAmB,AACnB,kCAAoC,AAC5B,0BAA4B,AACpC,eAAgB,AAChB,YAAa,AACb,iBAAkB,AAClB,wBAAyB,AACrB,qBAAsB,AAClB,uBAAwB,AAChC,UAAa,AACb,yBAA0B,AAC1B,UAAY,CACb,AACD,iCACE,UAAY,CACb,AACD,gCACE,wBAA2B,CAC5B","file":"Filter.vue","sourcesContent":["/*-----------------------------------------------------------------------------*/\n.form-button[data-v-0673c61c] {\n  background-color: transparent;\n  -webkit-box-shadow: none;\n          box-shadow: none;\n}\n.form-button .btn[data-v-0673c61c] {\n    background-color: #7e7e7e !important;\n    border-radius: 0px;\n    -webkit-box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.18) !important;\n            box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.18) !important;\n    color: white;\n    height: 40px;\n    margin-right: 14px;\n    min-width: 98px;\n    opacity: 1;\n}\n.form-button .btn--active[data-v-0673c61c] {\n      background-color: #29abe2 !important;\n}\n.divider-form[data-v-0673c61c] {\n  margin: 0 -20px;\n  width: 100vw;\n}\n.chip[data-v-0673c61c] {\n  background-color: #29abe2;\n  border-radius: 0px;\n  -webkit-box-shadow: none !important;\n          box-shadow: none !important;\n  font-size: 10px;\n  height: 18px;\n  line-height: 18px;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  padding: 0px;\n  text-transform: uppercase;\n  width: 65px;\n}\n.disabled-block[data-v-0673c61c] {\n  opacity: .5;\n}\n.btn-save-form[data-v-0673c61c] {\n  max-width: 100% !important;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1453:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1368);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(773)("068901a3", content, true);

/***/ }),

/***/ 1576:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "align-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('p', {
    staticClass: "title-form"
  }, [_vm._v("Datos de reserva")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "align-center": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs2": ""
    }
  }, [_c('v-subheader', {
    staticClass: "pl-0"
  }, [_vm._v("Código de Reserva")]), _vm._v(" "), _c('v-text-field', {
    staticClass: "input-border-inset",
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.params.code),
      callback: function($$v) {
        _vm.params.code = $$v
      },
      expression: "params.code"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs3": "",
      "px-2": ""
    }
  }, [_c('v-subheader', {
    staticClass: "pl-0"
  }, [_vm._v("Fecha de ingreso")]), _vm._v(" "), _c('v-menu', {
    staticClass: "menu-date-picker menu-form",
    attrs: {
      "lazy": "",
      "transition": "scale-transition",
      "offset-y": "",
      "full-width": "",
      "max-width": "290px"
    },
    model: {
      value: (_vm.menuEnter),
      callback: function($$v) {
        _vm.menuEnter = $$v
      },
      expression: "menuEnter"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Fecha de ingreso",
      "append-icon": "event",
      "single-line": "",
      "hide-details": "",
      "readonly": ""
    },
    slot: "activator",
    model: {
      value: (_vm.params.dateEnter),
      callback: function($$v) {
        _vm.params.dateEnter = $$v
      },
      expression: "params.dateEnter"
    }
  }), _vm._v(" "), _c('v-date-picker', {
    attrs: {
      "locale": "es-PE",
      "date-format": _vm.changeFormatDate,
      "formatted-value": _vm.formatted,
      "no-title": "",
      "scrollable": ""
    },
    on: {
      "input": _vm.validDate
    },
    model: {
      value: (_vm.params.dateEnter),
      callback: function($$v) {
        _vm.params.dateEnter = $$v
      },
      expression: "params.dateEnter"
    }
  })], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs3": "",
      "pr-2": ""
    }
  }, [_c('v-subheader', {
    staticClass: "pl-0"
  }, [_vm._v("Fecha de salida")]), _vm._v(" "), _c('v-menu', {
    staticClass: "menu-date-picker menu-form",
    attrs: {
      "lazy": "",
      "transition": "scale-transition",
      "offset-y": "",
      "full-width": "",
      "max-width": "290px"
    },
    model: {
      value: (_vm.menuOut),
      callback: function($$v) {
        _vm.menuOut = $$v
      },
      expression: "menuOut"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Fecha de salida",
      "append-icon": "event",
      "single-line": "",
      "hide-details": "",
      "readonly": ""
    },
    slot: "activator",
    model: {
      value: (_vm.params.dateOut),
      callback: function($$v) {
        _vm.params.dateOut = $$v
      },
      expression: "params.dateOut"
    }
  }), _vm._v(" "), _c('v-date-picker', {
    attrs: {
      "locale": "es-PE",
      "date-format": _vm.changeFormatDate,
      "formatted-value": _vm.formatted,
      "allowed-dates": _vm.allowedDatesOut,
      "no-title": "",
      "scrollable": ""
    },
    model: {
      value: (_vm.params.dateOut),
      callback: function($$v) {
        _vm.params.dateOut = $$v
      },
      expression: "params.dateOut"
    }
  })], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs2": ""
    }
  }, [_c('v-subheader', {
    staticClass: "pl-0"
  }, [_vm._v("Estado")]), _vm._v(" "), _c('v-select', {
    staticClass: "filter-select",
    attrs: {
      "items": _vm.status,
      "item-text": "name",
      "item-value": "id",
      "hide-details": "",
      "single-line": "",
      "bottom": ""
    },
    model: {
      value: (_vm.params.state),
      callback: function($$v) {
        _vm.params.state = $$v
      },
      expression: "params.state"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs2": "",
      "pl-2": ""
    }
  }, [_c('v-subheader', {
    staticClass: "pl-0"
  }, [_vm._v("Nº de Habitación")]), _vm._v(" "), _c('v-text-field', {
    staticClass: "input-border-inset",
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.params.room),
      callback: function($$v) {
        _vm.params.room = $$v
      },
      expression: "params.room"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "mt-4": ""
    }
  }, [_c('v-divider', {
    staticClass: "divider-form"
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('table-run', {
    staticClass: "no-selectable-table no-search-table",
    attrs: {
      "columns": _vm.columns,
      "rows": _vm.rows,
      "include-delete": false,
      "include-export-to-excel": false,
      "include-search": false,
      "selectable": false
    },
    scopedSlots: _vm._u([{
      key: "rows",
      fn: function(props) {
        return [_c('td', [_vm._v(_vm._s(props.row.code))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.row.customer.lastname) + ", " + _vm._s(props.row.customer.name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.row.country.code))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.row.dateEnter))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.row.dateOut))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.row.bookingRoom.type))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.row.bookingRoom.number))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.row.occupiedRoom.type))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.row.mp))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.row.anb))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.row.state))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.row.company))])]
      }
    }])
  })], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 797:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1453)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(1248),
  /* template */
  __webpack_require__(1576),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-0673c61c",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ })

});


// WEBPACK FOOTER //
// static/js/76.1918113bbe414e231099.js